export default __webpack_public_path__ + "static/media/cscs.ac686095.png";